import React from "react";
import ListItemButton from "@mui/material/ListItemButton";
import { SFStack } from "../../grid";
import SFTypography from "../../typography";
import { SFBetaIcon } from "../../icons";
import getStyled from "../../../hooks/getStyled";

const { styled } = getStyled();

export const StyledIcon = styled("div")(({ theme }) => ({
  width: 20,
  height: 20,
  color: theme.palette.grey400.main,
}));

// Hover and selected stylings are the same so its defined here.
const hoverAndSelectedStyling = (theme) => ({
  backgroundColor: theme.palette.grey100.main,
  "& .MuiSvgIcon-root": {
    fill: theme.palette.grey450.main,
  },
  "& .MuiTypography-root": {
    color: theme.palette.grey450.main,
  },
});

export const StyledListItem = styled("div")(({ theme }) => ({
  borderBottom: 0,
  "& .MuiListItemButton-root": {
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 13,
    paddingBottom: 13,
    justifyContent: "center",
    maxHeight: 92,
    borderBottom: `0.7px solid ${theme.palette.grey100.main}`,
    "& .MuiSvgIcon-root": {
      fill: theme.palette.grey400.main,
    },
    "& .MuiTypography-root": {
      textTransform: "uppercase",
      color: theme.palette.grey400.main,
    },
    "&:hover": {
      ...hoverAndSelectedStyling(theme),
    },
    "&.Mui-selected": {
      position: "relative",
      ...hoverAndSelectedStyling(theme),
      "&::before": {
        content: "\"\"",
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        width: "5px",
        backgroundColor: theme.palette.grey450.main,
      },
    },
  },
}));

export const MenuItem = ({
  label,
  selected,
  onClick,
  icon,
  devOnly = false,
}) => (
  <StyledListItem disablePadding>
    <ListItemButton selected={selected} onClick={onClick}>
      <SFStack alignItems="center" spacing={1}>
        <StyledIcon>{icon}</StyledIcon>
        <SFTypography variant="leftNav" align="center">
          {label}
        </SFTypography>
        {devOnly && <SFBetaIcon />}
      </SFStack>
    </ListItemButton>
  </StyledListItem>
);

export default MenuItem;
